const regions = [
  {
    code: 'CL-AP',
    name: 'Arica y Parinacota',
    ordinal: 'XV',
  },
  {
    code: 'CL-TA',
    name: 'Tarapacá',
    ordinal: 'I',
  },
  {
    code: 'CL-AN',
    name: 'Antofagasta',
    ordinal: 'II',
  },
  {
    code: 'CL-AT',
    name: 'Atacama',
    ordinal: 'III',
  },
  {
    code: 'CL-CO',
    name: 'Coquimbo',
    ordinal: 'IV',
  },
  {
    code: 'CL-VS',
    name: 'Valparaíso',
    ordinal: 'V',
  },
  {
    code: 'CL-LI',
    name: 'Libertador Gral. Bernardo O"Higgins',
    ordinal: 'VI',
  },
  {
    code: 'CL-ML',
    name: 'Maule',
    ordinal: 'VII',
  },
  {
    code: 'CL-BI',
    name: 'Biobío',
    ordinal: 'VIII',
  },
  {
    code: 'CL-AR',
    name: 'Araucanía',
    ordinal: 'IX',
  },
  {
    code: 'CL-LR',
    name: 'Los Ríos',
    ordinal: 'XIV',
  },
  {
    code: 'CL-LL',
    name: 'Los Lagos',
    ordinal: 'X',
  },
  {
    code: 'CL-AI',
    name: 'Aisén del Gral. Carlos Ibañez del Campo',
    ordinal: 'XI',
  },
  {
    code: 'CL-MA',
    name: 'Magallanes y de la Antártica Chilena',
    ordinal: 'XII',
  },
  {
    code: 'CL-RM',
    name: 'Metropolitana de Santiago',
    ordinal: 'XIII',
  },
];

export default regions;
